<template>
  <div>
    <Nav />
    
    <div id="app">
      <router-view/>
    </div>

    <div class="footer text-center">
      <div class="container">
        <div class="row">

          <!-- Footer Location -->
          <div class="col-lg-4 mb-5 mb-lg-0">
            <h4 class="text-uppercase mb-4">Plan du site</h4>
            <ul class="list-group">
              <li class="list-group-item"><router-link :to="{name: 'Home'}">Accueil</router-link></li>
              <li class="list-group-item"><a href="#">Qui sommes-nous ?</a></li>
              <li class="list-group-item"><a href="#">Contactez-nous</a></li>
              <li class="list-group-item"><router-link :to="{name: 'CookiesPage'}">Cookies</router-link></li>
              <li class="list-group-item"><router-link :to="{name: 'LegalPage'}">Mentions légales</router-link></li>
            </ul>
          </div>

          <!-- Footer Social Icons -->
          <div class="col-lg-4 mb-5 mb-lg-0">
            <h4 class="text-uppercase mb-4">Suivez-nous</h4>
            <a class="btn btn-outline-light btn-social mx-1" href="#">
              <i class="fab fa-fw fa-facebook-f"></i>
            </a>
            <a class="btn btn-outline-light btn-social mx-1" href="#">
              <i class="fab fa-fw fa-twitter"></i>
            </a>
            <a class="btn btn-outline-light btn-social mx-1" href="#">
              <i class="fab fa-fw fa-linkedin-in"></i>
            </a>
            <a class="btn btn-outline-light btn-social mx-1" href="#">
              <i class="fab fa-fw fa-dribbble"></i>
            </a>
          </div>

          <!-- Footer About Text -->
          <div class="col-lg-4">
            <h4 class="text-uppercase mb-4">&Agrave; propos</h4>
            <p class="lead mb-0"><span style="color:#1abc9c;">lookeoo</span> est une plateforme <span style="color:#1abc9c;">gratuite</span> visant à faciliter la <span style="color:#1abc9c;">recherche de biens immobiliers</span>.</p>
          </div>

        </div>
      </div>
    </div>

    <!-- Copyright Section -->
    <div class="copyright py-4 text-center text-white">
      <div class="container">
        <small>Copyright &copy; lookeoo</small>
      </div>
    </div>

    <CookieConsent />
  </div>
</template>

<script>
// import { Component, Vue } from 'vue-property-decorator';
import Nav from "./components/template/Nav.vue"; // @ is an alias to /src
import CookieConsent from "./components/template/CookieConsent.vue"; // @ is an alias to /src

export default {
  name: 'App',
  components: { Nav, CookieConsent }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0px;
}

.jumbotron{
  padding-top: 20px;
  padding-bottom: 20px;
  background: #1abc9c;
  font-family: Montserrat,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji";
  border-radius: 0;
}

.jumbotron h1{
  color: #fff;
  text-transform: uppercase;
  font-weight: 600;
  text-decoration: underline;
  padding-bottom: 10px;
}

.jumbotron h4{
  font-size: 18px;
}

.topbar{
  background: #1a252f;
  height: 48px;
}

.topbar .breadcrumb{
  margin-bottom: 0;
  background-color: transparent !important;
  color: #fff;
}

.topbar .breadcrumb .breadcrumb-item {
  color: #fff;
}
.topbar .breadcrumb .breadcrumb-item a{
  color: #fff;
  font-weight: bold;
}

.topbar .nav .nav-item a.nav-link{
  color: #1abc9c;
  padding: 0.75rem 1rem;
}

.footer{
  margin-top: 50px;
  font-family: Lato,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji";
}

.footer a{
  color: #1abc9c;
}

.hide{
  display: none !important;
}

.topbar .dropdown{
  margin-top: 4px;
  margin-right: 4px;
}

@media (max-width: 768px) {
  .collapse-md{
    display: none;
  }

  .jumbotron{
    padding-top: 40px;
  }
}

@media (min-width: 768px){
  .expand-md{
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue